import type { IMyHomeV2Schema } from '../repositories/price-estimator/entities/card/MyHomeV2Schema';
import { IHowToEarnSchema } from '../repositories/price-estimator/entities/how_to_earn/HowToEarnSchema';

export enum EProfitStatus {
  init = 'init',
  loading = 'loading',
  succeed = 'succeed',
  failed = 'failed',
}

export interface IPageState {
  myHomeId: number;
  myHomesList: IMyHomeV2Schema[];
  profit: {
    data: IHowToEarnSchema | null;
    status: EProfitStatus;
  };
  modals: {
    isOnboardingModalOpen: boolean;
    isRentModalOpen: boolean;
    isSaleModalOpen: boolean;
  };
}
